"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _BaseSeoManager2 = _interopRequireDefault(require("../BaseSeoManager"));

var _Helmet = require("../meta/Helmet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MANAGER_TYPE = _SeoManagerHelpers.HELPER_MANAGER_TYPE.APRO;
var DEBUG_CONSOLE = false;
var IS_AGENT_PRO_ROOT_LEVEL = 'AgentiProRootLevel';
var IS_AGENT_PRO_ID_LEVEL = 'AgentiProLevel';
var IS_AGENT_PRO_CLOSURE = 'AgentProClosure';
var CHECK_LEVEL_AGENT_PRO_CLOSURE = {
  agentProClosure: true
};
var CHECK_LEVEL_AGENT_PRO_ROOT = {
  agentProId: CHECK_LEVEL_AGENT_PRO_CLOSURE
};
var CHECK_LEVEL = {
  agentProRoot: CHECK_LEVEL_AGENT_PRO_ROOT,
  agentProClosure: CHECK_LEVEL_AGENT_PRO_CLOSURE
};

var AgentProSeoManager = /*#__PURE__*/function (_BaseSeoManager) {
  _inherits(AgentProSeoManager, _BaseSeoManager);

  var _super = _createSuper(AgentProSeoManager);

  function AgentProSeoManager(domain, lang) {
    var _this;

    _classCallCheck(this, AgentProSeoManager);

    _this = _super.call(this, domain, lang);
    _this.immotype = undefined;
    _this.encode_parts = {};
    _this.encode_qs = [];
    _this.locations = [];
    _this.num_levels = 0;
    _this.max_levels = 0;
    _this.level_prec = null;
    _this.tree = null;
    return _this;
  }

  _createClass(AgentProSeoManager, [{
    key: "debugConsole",
    value: function debugConsole(caption, value) {
      if (!DEBUG_CONSOLE) {
        return false;
      }
    }
  }, {
    key: "decodeLevel",
    value: function decodeLevel(level, value) {
      var _this2 = this;

      this.debugConsole("\n* decodeLevel");
      this.debugConsole('level', level);
      this.debugConsole('value', value);

      if (!this.isValidDecode()) {
        return;
      }

      this.valid_levels["level".concat(level)] = false;
      this.level_prec = level === 1 ? null : this.data.seo_decode_type["level".concat(level - 1)];

      var getCheckLevel = function getCheckLevel(dispayValue) {
        _this2.debugConsole('is', dispayValue); // console.log('dispayValue', dispayValue)
        // console.log('this.data.seo_decode_type', this.data.seo_decode_type)


        Object.keys(_this2.data.seo_decode_type).map(function (key, idx) {
          var levelName = _this2.data.seo_decode_type[key]; //console.log(idx, levelName, this.tree[levelName]);

          if (idx === 0) {
            _this2.tree = Object.assign({}, CHECK_LEVEL[levelName]);
          } else {
            _this2.tree = _this2.tree[levelName];
          }
        });

        if (_this2.tree) {
          _this2.valid_levels["level".concat(level)] = true;
        } else {
          _this2.debugConsole("valid_level_".concat(level), "".concat(_this2.valid_levels["level".concat(level)], ", ").concat(_this2.data.seo_decode_type["level".concat(level)]));
        }
      };

      if (this.isAgentProRootLevel(value, level)) {
        getCheckLevel(IS_AGENT_PRO_ROOT_LEVEL);
      } else if (this.isAgentProIdLevel(value, level)) {
        getCheckLevel(IS_AGENT_PRO_ID_LEVEL);
      } else if (this.isAgentProClosure(value, level)) {
        getCheckLevel(IS_AGENT_PRO_CLOSURE);
      }

      this.debugConsole("valid_level_".concat(level), "".concat(this.valid_levels["level".concat(level)], "\n"));
    }
  }, {
    key: "isAgentProRootLevel",
    value: function isAgentProRootLevel(value, level) {
      if (_SeoManagerHelpers.PUB_DECODE_FOR_ESAPI[this.lang][value] !== undefined) {
        this.addDecodeData("level".concat(level), 'agentProRoot');
        return true;
      }

      return false;
    }
  }, {
    key: "isAgentProIdLevel",
    value: function isAgentProIdLevel(value, level) {
      var parts = value.split('-');
      var pubID = parts.pop(); // parts[parts.length - 1];

      var agentProSlug = parts.length > 0 ? "".concat(parts.join('-'), "-") : ''; // console.log(parts[parts.length - 1], typeof parts[parts.length - 1], typeof parseInt(parts[parts.length - 1], 10), parts[0], typeof parseInt(parts[0], 10), parseInt(parts[0], 10));

      if (!isNaN(parseInt(pubID, 10))) {
        this.addData('publisherId', pubID);
        this.addData('publisherSlug', agentProSlug);
        this.addData('isAgentProPage', true);
        this.addDecodeData("level".concat(level), 'agentProId');
        return true;
      }

      return false;
    }
  }, {
    key: "isAgentProClosure",
    value: function isAgentProClosure(value, level) {
      if (value === 'agenti' && level === 3) {
        this.addDecodeData("level".concat(level), 'agentProClosure');
        return true;
      }

      return false;
    }
  }, {
    key: "createSeoData",
    value: function createSeoData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locations = _ref.locations,
          total_listings = _ref.total_listings,
          seoParams = _ref.seoParams,
          isSrpUrl = _ref.isSrpUrl;

      this.seo_data.seo = (0, _Helmet.getHelmet)({
        domain: this.domain,
        lang: this.lang,
        seodata: this.data,
        locations: locations,
        count: total_listings,
        seoParams: seoParams,
        pageType: 'AgentPro',
        isSrpUrl: isSrpUrl
      });
    }
  }], [{
    key: "getLevel1Slug",
    value: function getLevel1Slug() {
      return {
        type: MANAGER_TYPE,
        regexp: /^\/(agenzie\/.+\/agenti(\/$|\?.+|\/\?.*|$))/,
        isRegExp: true
      };
    }
  }]);

  return AgentProSeoManager;
}(_BaseSeoManager2["default"]);

var _default = AgentProSeoManager;
exports["default"] = _default;